(function () {
  var PROMO_VIDEO_SELECTOR =
    '.product-card--promo video.collection-promo-media, .product-card--collection-video video.collection-product-video-media, .collection-promo-card__media video, .collection-promo-split__media video, .collection-promo-two-col__media video';

  var PRODUCT_VIDEO_SELECTOR = '.product-card--collection-video video.collection-product-video-media';
  var VIDEO_SPLIT_TEMPLATES = ['split-cards-width-video', 'men-s-collection'];
  var VIDEO_SPLIT_SCOPE_SELECTOR = VIDEO_SPLIT_TEMPLATES.map(function (suffix) {
    return '[data-collection-template="' + suffix + '"][data-collection-product-videos="true"]';
  }).join(',');
  var VIDEO_DEBUG_KEY = 'aureline:collection-video-debug';

  var PRELOAD_ROOT_MARGIN = '480px 0px';
  var MOBILE_PRELOAD_ROOT_MARGIN = '240px 0px';
  var MOBILE_PLAY_ROOT_MARGIN = '120px 0px';
  var PAUSE_DELAY_MS = 450;
  var MOBILE_PAUSE_DELAY_MS = 120;
  var VIDEO_SPLIT_PAUSE_DELAY_MS = 900;
  var MOBILE_PRELOAD_TIMEOUT_MS = 10000;
  var IOS_PAUSE_DELAY_MS = 800;
  var MOBILE_RESTORE_DELAYS = [50, 150, 350, 700, 1200, 2000];
  var DESKTOP_RESTORE_DELAYS = [100, 350];

  var pauseTimers = new WeakMap();
  var videoObservers = new WeakMap();
  var videoLastTimes = new WeakMap();
  var restoreTimerIds = [];
  var scrollRecoveryTimer;
  var pageHasBeenHidden = false;
  var videoDebugLoads = [];
  var IS_TOUCH_DEVICE =
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(hover: none) and (pointer: coarse)').matches;

  function isProductCollectionVideo(video) {
    return !!(video && video.classList && video.classList.contains('collection-product-video-media'));
  }

  function getNetworkConnection() {
    return navigator.connection || navigator.mozConnection || navigator.webkitConnection || null;
  }

  /* Slow 4G / 3G / slower (and Save-Data). Fast 4G keeps effectiveType "4g". */
  function isSlowCollectionNetwork() {
    if (typeof window.isSlowCollectionNetwork === 'function' && window.isSlowCollectionNetwork !== isSlowCollectionNetwork) {
      try {
        return window.isSlowCollectionNetwork();
      } catch (error) {}
    }

    if (typeof navigator !== 'undefined' && navigator.onLine === false) {
      return true;
    }

    var connection = getNetworkConnection();

    if (!connection) {
      return false;
    }

    if (connection.saveData) {
      return true;
    }

    var effectiveType = connection.effectiveType;

    return effectiveType === 'slow-2g' || effectiveType === '2g' || effectiveType === '3g';
  }

  function syncSlowNetworkVideoCardsFlag() {
    if (isSlowCollectionNetwork()) {
      document.documentElement.setAttribute('data-collection-videos-slow-net', 'true');
    } else {
      document.documentElement.removeAttribute('data-collection-videos-slow-net');
    }
  }

  function suspendSlowNetworkCollectionVideos(root) {
    if (!isSlowCollectionNetwork()) {
      return false;
    }

    var scope = root && typeof root.querySelectorAll === 'function' ? root : document;

    syncSlowNetworkVideoCardsFlag();

    scope.querySelectorAll(PRODUCT_VIDEO_SELECTOR).forEach(function (video) {
      forceSuspendCollectionVideo(video);
    });

    return true;
  }

  function hasCollectionVideos(root) {
    var scope = root && typeof root.querySelector === 'function' ? root : document;
    return !!scope.querySelector(PROMO_VIDEO_SELECTOR);
  }

  function isVideoSplitScope(root) {
    var node = root;

    if (!node || node === document) {
      return !!document.querySelector(VIDEO_SPLIT_SCOPE_SELECTOR);
    }

    if (node.nodeType !== 1) {
      return false;
    }

    if (
      node.getAttribute &&
      VIDEO_SPLIT_TEMPLATES.indexOf(node.getAttribute('data-collection-template')) !== -1 &&
      node.getAttribute('data-collection-product-videos') === 'true'
    ) {
      return true;
    }

    if (node.closest && node.closest(VIDEO_SPLIT_SCOPE_SELECTOR)) {
      return true;
    }

    if (node.querySelector && node.querySelector(VIDEO_SPLIT_SCOPE_SELECTOR)) {
      return true;
    }

    return false;
  }

  function isVideoSplitVideo(video) {
    return isProductCollectionVideo(video) && isVideoSplitScope(video);
  }

  function isMobileViewport() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  function isIOSSafari() {
    if (typeof navigator === 'undefined') {
      return false;
    }

    var ua = navigator.userAgent || '';
    var isIOSDevice = /iPad|iPhone|iPod/i.test(ua);
    var isIPadOS = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;

    return isIOSDevice || isIPadOS;
  }

  function isMobileVideoContext() {
    return IS_TOUCH_DEVICE || isMobileViewport() || isIOSSafari();
  }

  function getPauseDelayMs(video) {
    if (isVideoSplitVideo(video)) {
      return VIDEO_SPLIT_PAUSE_DELAY_MS;
    }

    if (isIOSSafari()) {
      return IOS_PAUSE_DELAY_MS;
    }

    if (IS_TOUCH_DEVICE || isMobileViewport()) {
      return MOBILE_PAUSE_DELAY_MS;
    }

    return PAUSE_DELAY_MS;
  }

  function shouldInvokeVideoLoad(video) {
    if (!video) {
      return false;
    }

    if (isIOSSafari()) {
      if (video.error) {
        return true;
      }

      if (video.networkState === HTMLMediaElement.NETWORK_EMPTY) {
        return true;
      }

      if (video.networkState === HTMLMediaElement.NETWORK_LOADING) {
        return false;
      }

      if (video.readyState >= HTMLMediaElement.HAVE_METADATA) {
        return false;
      }

      return video.dataset.promoVideoIosLoadAttempted !== 'true';
    }

    return shouldReloadVideo(video);
  }

  function getVideoSplitPreloadRootMargin() {
    return Math.max(480, Math.round(window.innerHeight * 1.5)) + 'px 0px';
  }

  function getVideoSplitPlayRootMargin() {
    return '160px 0px';
  }

  function getPromoPreloadRootMargin(video) {
    if (isVideoSplitVideo(video)) {
      return getVideoSplitPreloadRootMargin();
    }

    if (IS_TOUCH_DEVICE || isMobileViewport()) {
      return MOBILE_PRELOAD_ROOT_MARGIN;
    }

    return PRELOAD_ROOT_MARGIN;
  }

  function getPromoPlayRootMargin(video) {
    if (isVideoSplitVideo(video)) {
      return getVideoSplitPlayRootMargin();
    }

    if (IS_TOUCH_DEVICE || isMobileViewport()) {
      return MOBILE_PLAY_ROOT_MARGIN;
    }

    return '0px 0px';
  }

  function shouldFastStartPromoVideo(video) {
    return isVideoSplitVideo(video) || IS_TOUCH_DEVICE || isMobileViewport();
  }

  function bindVideoLifecycleHandlers(video) {
    if (!video || video.dataset.promoVideoLifecycleBound === 'true') {
      return;
    }

    video.dataset.promoVideoLifecycleBound = 'true';

    function markReady() {
      video.dataset.promoVideoPreloading = '';
      delete video.dataset.promoVideoPreloadSince;
    }

    video.addEventListener('loadeddata', markReady, { passive: true });
    video.addEventListener('canplay', markReady, { passive: true });
    video.addEventListener('playing', markReady, { passive: true });
    video.addEventListener(
      'error',
      function () {
        video.dataset.promoVideoPreloading = '';
        video.dataset.promoVideoAwaitingPlay = '';
        delete video.dataset.promoVideoPreloadSince;
      },
      { passive: true }
    );
  }

  function clearVideoPreloadState(video) {
    if (!video) {
      return;
    }

    video.dataset.promoVideoPreloading = '';
    delete video.dataset.promoVideoPreloadSince;
  }

  function getCollectionVideoDevice(video) {
    if (!video) {
      return null;
    }

    var wrapper = video.closest('.collection-product-video-device');

    if (wrapper) {
      return wrapper.getAttribute('data-collection-video-device');
    }

    return video.getAttribute('data-collection-video-device');
  }

  function isDeviceSpecificCollectionVideo(video) {
    return isProductCollectionVideo(video) && !!getCollectionVideoDevice(video);
  }

  function isVideoDisplayed(video) {
    if (!video || !video.isConnected) {
      return false;
    }

    if (isProductCollectionVideo(video) && isSlowCollectionNetwork()) {
      return false;
    }

    var device = getCollectionVideoDevice(video);
    var visibilityTarget = video.closest('.collection-product-video-device') || video;

    if (device === 'mobile' && !isMobileViewport()) {
      return false;
    }

    if (device === 'desktop' && isMobileViewport()) {
      return false;
    }

    return window.getComputedStyle(visibilityTarget).display !== 'none';
  }

  function isVideoDebugEnabled() {
    try {
      if (window.location.search.indexOf('video_debug=1') !== -1) {
        return true;
      }

      return localStorage.getItem(VIDEO_DEBUG_KEY) === '1';
    } catch (error) {
      return window.location.search.indexOf('video_debug=1') !== -1;
    }
  }

  function formatDebugBytes(bytes) {
    if (!bytes) {
      return '0 B';
    }

    if (bytes < 1024) {
      return bytes + ' B';
    }

    if (bytes < 1048576) {
      return (bytes / 1024).toFixed(1) + ' KB';
    }

    return (bytes / 1048576).toFixed(2) + ' MB';
  }

  function getVideoDebugInfo(video) {
    var card = video ? video.closest('.product-card--collection-video') : null;
    var src = video.currentSrc || video.getAttribute('src') || '';
    var sourceEl = video.querySelector('source');

    if (!src && sourceEl) {
      src = sourceEl.getAttribute('src') || '';
    }

    if (!src && video.dataset.collectionVideoSrc) {
      src = video.dataset.collectionVideoSrc;
    }

    if (!src && video.dataset.collectionVideoSources) {
      try {
        var savedSources = JSON.parse(video.dataset.collectionVideoSources);

        if (savedSources[0] && savedSources[0].src) {
          src = savedSources[0].src;
        }
      } catch (error) {}
    }

    return {
      device: getCollectionVideoDevice(video) || 'unknown',
      handle:
        (card && (card.getAttribute('data-split-product-handle') || card.getAttribute('handle'))) || '',
      filename: src ? src.split('/').pop().split('?')[0] : '(no src)',
      url: src,
      displayed: isVideoDisplayed(video),
      suspended: video.dataset.collectionVideoSuspended === 'true'
    };
  }

  function findVideoForResourceUrl(url) {
    var match = null;

    if (!url) {
      return match;
    }

    var filename = url.split('/').pop().split('?')[0];

    document.querySelectorAll(PRODUCT_VIDEO_SELECTOR).forEach(function (video) {
      var info = getVideoDebugInfo(video);

      if (
        (info.url && url.indexOf(info.url.split('?')[0]) !== -1) ||
        (filename && info.filename === filename)
      ) {
        match = video;
      }
    });

    return match;
  }

  function logVideoDebugLoad(entry) {
    if (!isVideoDebugEnabled()) {
      return;
    }

    var name = entry.name || '';
    var isVideoResource =
      entry.initiatorType === 'video' ||
      /\.(mp4|webm|m3u8)(\?|$)/i.test(name) ||
      (name.indexOf('/videos/') !== -1 && name.indexOf('cdn.shopify.com') !== -1);

    if (!isVideoResource) {
      return;
    }

    var matchedVideo = findVideoForResourceUrl(name);
    var info = matchedVideo ? getVideoDebugInfo(matchedVideo) : null;
    var row = {
      device: info ? info.device : '?',
      handle: info ? info.handle : '',
      displayed: info ? info.displayed : null,
      suspended: info ? info.suspended : null,
      size: formatDebugBytes(entry.transferSize || entry.encodedBodySize || 0),
      bytes: entry.transferSize || entry.encodedBodySize || 0,
      filename: name.split('/').pop().split('?')[0],
      url: name
    };

    videoDebugLoads.push(row);

    if (info && info.displayed === false) {
      console.warn(
        '%c[Aureline Video] WRONG DEVICE LOAD',
        'color:#c00;font-weight:bold',
        row.device,
        row.size,
        row.filename,
        info
      );
      return;
    }

    console.log(
      '%c[Aureline Video] loaded',
      'color:#0a7',
      row.device,
      row.size,
      row.filename,
      info && info.handle ? '(' + info.handle + ')' : ''
    );
  }

  function initVideoLoadDebugger() {
    if (!isVideoDebugEnabled() || !isVideoSplitScope()) {
      return;
    }

    videoDebugLoads = [];

    var viewport = isMobileViewport() ? 'mobile' : 'desktop';

    console.group('%c[Aureline Video Debug] ' + viewport + ' viewport', 'color:#0a7;font-weight:bold');
    console.info('Debug on: ?video_debug=1 or localStorage.setItem("' + VIDEO_DEBUG_KEY + '", "1")');
    console.info('Disable: localStorage.removeItem("' + VIDEO_DEBUG_KEY + '")');

    document.querySelectorAll(PRODUCT_VIDEO_SELECTOR).forEach(function (video) {
      var info = getVideoDebugInfo(video);

      console.log(
        (info.displayed ? 'VISIBLE' : 'HIDDEN') + ' [' + info.device + ']',
        info.handle || info.filename,
        info.suspended ? '(sources suspended)' : ''
      );
    });

    if ('PerformanceObserver' in window) {
      try {
        var observer = new PerformanceObserver(function (list) {
          list.getEntries().forEach(logVideoDebugLoad);
        });

        observer.observe({ type: 'resource', buffered: true });
      } catch (error) {}
    }

    document.querySelectorAll(PRODUCT_VIDEO_SELECTOR).forEach(function (video) {
      video.addEventListener(
        'loadstart',
        function () {
          if (!isVideoDisplayed(video)) {
            console.warn('[Aureline Video] Hidden video tried to load:', getVideoDebugInfo(video));
          }
        },
        { passive: true }
      );
    });

    window.setTimeout(function () {
      var wrongDeviceLoads = videoDebugLoads.filter(function (row) {
        return row.displayed === false;
      });
      var totalBytes = videoDebugLoads.reduce(function (sum, row) {
        return sum + (row.bytes || 0);
      }, 0);

      console.log('Summary:', videoDebugLoads.length, 'video requests,', formatDebugBytes(totalBytes), 'total');

      if (videoDebugLoads.length) {
        console.table(videoDebugLoads);
      }

      if (wrongDeviceLoads.length) {
        console.error(
          wrongDeviceLoads.length + ' hidden-device video request(s) still loaded. Check table above.'
        );
      } else {
        console.log('No wrong-device video network loads detected.');
      }

      console.groupEnd();
    }, 5000);

    window.AurelineVideoDebug = {
      getLoads: function () {
        return videoDebugLoads.slice();
      },
      logVideos: function () {
        document.querySelectorAll(PRODUCT_VIDEO_SELECTOR).forEach(function (video) {
          console.log(getVideoDebugInfo(video));
        });
      }
    };
  }

  function forceSuspendCollectionVideo(video) {
    if (!video || !isProductCollectionVideo(video)) {
      return;
    }

    pausePromoVideo(video);
    video.setAttribute('preload', 'none');
    video.dataset.promoVideoPreloading = '';
    video.dataset.promoVideoAwaitingPlay = '';

    if (video.dataset.collectionVideoSuspended === 'true') {
      return;
    }

    var sources = video.querySelectorAll('source');

    if (sources.length > 0) {
      var savedSources = [];

      sources.forEach(function (source) {
        savedSources.push({
          src: source.getAttribute('src') || '',
          type: source.getAttribute('type') || ''
        });
        source.removeAttribute('src');
      });

      video.dataset.collectionVideoSources = JSON.stringify(savedSources);
    } else if (video.getAttribute('src')) {
      video.dataset.collectionVideoSrc = video.getAttribute('src');
      video.removeAttribute('src');
    }

    if (video.getAttribute('poster')) {
      video.dataset.collectionVideoPoster = video.getAttribute('poster');
      video.removeAttribute('poster');
    }

    video.dataset.collectionVideoSuspended = 'true';

    try {
      video.load();
    } catch (error) {}
  }

  function suspendHiddenDeviceVideo(video) {
    if (!isDeviceSpecificCollectionVideo(video) || isVideoDisplayed(video)) {
      return;
    }

    forceSuspendCollectionVideo(video);
  }

  function activateDisplayedDeviceVideo(video) {
    if (!isDeviceSpecificCollectionVideo(video) || !isVideoDisplayed(video)) {
      return;
    }

    if (isSlowCollectionNetwork()) {
      forceSuspendCollectionVideo(video);
      return;
    }

    video.setAttribute('preload', 'auto');

    if (video.dataset.collectionVideoSuspended !== 'true') {
      return;
    }

    var sources = video.querySelectorAll('source');
    var savedSources = [];

    try {
      savedSources = JSON.parse(video.dataset.collectionVideoSources || '[]');
    } catch (error) {
      savedSources = [];
    }

    if (sources.length > 0 && savedSources.length > 0) {
      sources.forEach(function (source, index) {
        if (!savedSources[index]) {
          return;
        }

        source.setAttribute('src', savedSources[index].src);

        if (savedSources[index].type) {
          source.setAttribute('type', savedSources[index].type);
        }
      });
    } else if (video.dataset.collectionVideoSrc) {
      video.setAttribute('src', video.dataset.collectionVideoSrc);
    }

    if (video.dataset.collectionVideoPoster) {
      video.setAttribute('poster', video.dataset.collectionVideoPoster);
    }

    delete video.dataset.collectionVideoSources;
    delete video.dataset.collectionVideoSrc;
    delete video.dataset.collectionVideoPoster;
    delete video.dataset.collectionVideoSuspended;
    video.dataset.promoVideoPreloading = '';
  }

  function syncDeviceVideoSources(root) {
    var scope = root && typeof root.querySelectorAll === 'function' ? root : document;

    scope.querySelectorAll(PRODUCT_VIDEO_SELECTOR).forEach(function (video) {
      if (isVideoDisplayed(video)) {
        activateDisplayedDeviceVideo(video);
      } else {
        suspendHiddenDeviceVideo(video);
      }
    });
  }

  function isInViewport(el) {
    var rect = el.getBoundingClientRect();
    return rect.bottom > 0 && rect.top < window.innerHeight && rect.right > 0 && rect.left < window.innerWidth;
  }

  function isNearViewport(el, video) {
    var margin = isVideoSplitVideo(video) ? window.innerHeight * 1.5 : 480;
    var rect = el.getBoundingClientRect();
    return (
      rect.bottom > -margin &&
      rect.top < window.innerHeight + margin &&
      rect.right > 0 &&
      rect.left < window.innerWidth
    );
  }

  function shouldReloadVideo(video) {
    if (!video || video.tagName !== 'VIDEO') {
      return false;
    }

    if (video.error) {
      return true;
    }

    return (
      video.networkState === HTMLMediaElement.NETWORK_EMPTY ||
      (video.readyState === HTMLMediaElement.HAVE_NOTHING &&
        video.networkState !== HTMLMediaElement.NETWORK_LOADING)
    );
  }

  function isStalledVideo(video) {
    if (!video || video.tagName !== 'VIDEO' || !video.isConnected) {
      return false;
    }

    if (video.error || shouldReloadVideo(video)) {
      return true;
    }

    if (!isInViewport(video)) {
      return false;
    }

    if (video.paused || video.readyState < HTMLMediaElement.HAVE_CURRENT_DATA) {
      return true;
    }

    if (video.dataset.promoVideoPreloading === 'true') {
      return true;
    }

    return false;
  }

  function resetVideoPlaybackFlags(video) {
    if (!video || video.tagName !== 'VIDEO') {
      return;
    }

    clearScheduledPause(video);
    video.dataset.promoVideoAwaitingPlay = '';

    if (shouldReloadVideo(video) || video.error || video.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA) {
      clearVideoPreloadState(video);
    }
  }

  function preparePromoVideo(video) {
    if (!video || video.tagName !== 'VIDEO') {
      return;
    }

    bindVideoLifecycleHandlers(video);

    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.loop = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.setAttribute('loop', '');

    if (isDeviceSpecificCollectionVideo(video)) {
      if (!isVideoDisplayed(video)) {
        video.setAttribute('preload', 'none');
        return;
      }

      video.setAttribute('preload', 'auto');
      return;
    }

    if (isIOSSafari()) {
      if (isInViewport(video) || isNearViewport(video, video)) {
        video.setAttribute('preload', 'auto');
      } else if (video.getAttribute('preload') !== 'metadata') {
        video.setAttribute('preload', 'metadata');
      }

      return;
    }

    if (video.getAttribute('preload') !== 'auto') {
      video.setAttribute('preload', 'auto');
    }
  }

  function preloadPromoVideo(video) {
    if (!video || video.tagName !== 'VIDEO') {
      return;
    }

    if (isProductCollectionVideo(video) && isSlowCollectionNetwork()) {
      forceSuspendCollectionVideo(video);
      return;
    }

    bindVideoLifecycleHandlers(video);

    if (isDeviceSpecificCollectionVideo(video) && !isVideoDisplayed(video)) {
      suspendHiddenDeviceVideo(video);
      return;
    }

    if (isDeviceSpecificCollectionVideo(video)) {
      activateDisplayedDeviceVideo(video);
    }

    preparePromoVideo(video);

    if (video.dataset.promoVideoPreloading === 'true') {
      if (video.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA) {
        clearVideoPreloadState(video);
      } else {
        var preloadSince = parseInt(video.dataset.promoVideoPreloadSince || '0', 10);

        if (preloadSince && Date.now() - preloadSince < MOBILE_PRELOAD_TIMEOUT_MS) {
          return;
        }

        clearVideoPreloadState(video);
      }
    }

    if (!shouldInvokeVideoLoad(video)) {
      return;
    }

    video.dataset.promoVideoPreloading = 'true';
    video.dataset.promoVideoPreloadSince = String(Date.now());

    if (isIOSSafari()) {
      video.dataset.promoVideoIosLoadAttempted = 'true';
    }

    try {
      if (isIOSSafari() && video.readyState < HTMLMediaElement.HAVE_METADATA) {
        video.load();
      } else if (!isIOSSafari()) {
        video.load();
      }
    } catch (error) {
      clearVideoPreloadState(video);

      if (isIOSSafari()) {
        delete video.dataset.promoVideoIosLoadAttempted;
      }
    }
  }

  function clearScheduledPause(video) {
    var timer = pauseTimers.get(video);

    if (timer) {
      clearTimeout(timer);
      pauseTimers.delete(video);
    }
  }

  function schedulePause(video) {
    clearScheduledPause(video);

    if (isIOSSafari() && isInViewport(video)) {
      return;
    }

    var delay = getPauseDelayMs(video);

    pauseTimers.set(
      video,
      setTimeout(function () {
        pauseTimers.delete(video);

        if (!video.isConnected) {
          return;
        }

        if (!isInViewport(video)) {
          pausePromoVideo(video);
        }
      }, delay)
    );
  }

  function attemptPlay(video, attempt) {
    attempt = attempt || 0;

    if (!video.isConnected || !video.paused || !isVideoDisplayed(video)) {
      return;
    }

    preparePromoVideo(video);

    var promise;

    try {
      promise = video.play();
    } catch (error) {
      promise = null;
    }

    if (!promise || typeof promise.catch !== 'function') {
      return;
    }

    promise.catch(function () {
      if (attempt >= (isIOSSafari() ? 8 : 5) || !video.isConnected) {
        return;
      }

      if (
        attempt >= 1 &&
        (shouldInvokeVideoLoad(video) || video.readyState < HTMLMediaElement.HAVE_CURRENT_DATA)
      ) {
        clearVideoPreloadState(video);
        video.dataset.promoVideoAwaitingPlay = '';

        if (!isIOSSafari()) {
          preloadPromoVideo(video);
        }
      }

      setTimeout(
        function () {
          attemptPlay(video, attempt + 1);
        },
        (isIOSSafari() ? 150 : 90) * (attempt + 1)
      );
    });
  }

  function playPromoVideo(video, options) {
    options = options || {};

    if (!video || video.tagName !== 'VIDEO' || !isVideoDisplayed(video)) {
      if (video && video.tagName === 'VIDEO' && !isVideoDisplayed(video) && !video.paused) {
        pausePromoVideo(video);
      }

      if (video && isDeviceSpecificCollectionVideo(video)) {
        suspendHiddenDeviceVideo(video);
      }

      return;
    }

    var fastStart = options.fastStart || shouldFastStartPromoVideo(video);

    if (options.force) {
      video.dataset.promoVideoAwaitingPlay = '';

      if (video.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA || video.error) {
        clearVideoPreloadState(video);
      }
    }

    clearScheduledPause(video);
    preparePromoVideo(video);
    preloadPromoVideo(video);

    if (!video.paused && video.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA) {
      return;
    }

    if (video.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA) {
      attemptPlay(video, 0);
    } else if (isIOSSafari()) {
      attemptPlay(video, 0);
    }

    if (!fastStart && video.readyState >= HTMLMediaElement.HAVE_FUTURE_DATA) {
      return;
    }

    if (video.dataset.promoVideoAwaitingPlay === 'true' && !options.force) {
      return;
    }

    video.dataset.promoVideoAwaitingPlay = 'true';

    function onReady() {
      video.dataset.promoVideoAwaitingPlay = '';
      attemptPlay(video, 0);
    }

    if (fastStart) {
      video.addEventListener('loadeddata', onReady, { once: true });
      video.addEventListener('canplay', onReady, { once: true });
      video.addEventListener('playing', onReady, { once: true });
    }

    video.addEventListener('canplaythrough', onReady, { once: true });
  }

  function pausePromoVideo(video) {
    if (!video || video.tagName !== 'VIDEO' || video.paused) {
      return;
    }

    video.dataset.promoVideoAwaitingPlay = '';
    video.pause();
  }

  function recoverStalledVideo(video) {
    if (!video || !video.isConnected) {
      return;
    }

    if (isDeviceSpecificCollectionVideo(video) && !isVideoDisplayed(video)) {
      suspendHiddenDeviceVideo(video);
      return;
    }

    var inView = isInViewport(video);
    var near = isNearViewport(video, video);

    if (!inView && !near) {
      return;
    }

    if (!isStalledVideo(video) && !inView) {
      preloadPromoVideo(video);
      return;
    }

    if (!isStalledVideo(video)) {
      return;
    }

    resetVideoPlaybackFlags(video);
    preparePromoVideo(video);

    if (shouldReloadVideo(video) || video.error) {
      try {
        video.load();
      } catch (error) {}
    }

    if (inView) {
      if (video.dataset.promoVideoWasPlaying === 'true') {
        video.dataset.promoVideoWasPlaying = '';
        playPromoVideo(video, { fastStart: true, force: true });
        return;
      }

      playPromoVideo(video, { fastStart: isVideoSplitVideo(video), force: true });
      return;
    }

    preloadPromoVideo(video);
  }

  function preloadVideosInSubtree(root) {
    if (!root || typeof root.querySelectorAll !== 'function') {
      return;
    }

    syncDeviceVideoSources(root);

    root.querySelectorAll(PROMO_VIDEO_SELECTOR).forEach(function (video) {
      if (isDeviceSpecificCollectionVideo(video) && !isVideoDisplayed(video)) {
        suspendHiddenDeviceVideo(video);
        return;
      }

      preloadPromoVideo(video);

      if (isInViewport(video) && isVideoDisplayed(video)) {
        playPromoVideo(video, { fastStart: isVideoSplitVideo(video), force: true });
      }
    });
  }

  function syncPromoVideosState(root) {
    var scope = root && typeof root.querySelectorAll === 'function' ? root : document;

    syncSlowNetworkVideoCardsFlag();

    if (suspendSlowNetworkCollectionVideos(scope)) {
      return;
    }

    syncDeviceVideoSources(scope);

    scope.querySelectorAll(PROMO_VIDEO_SELECTOR).forEach(function (video) {
      resetVideoPlaybackFlags(video);
      preparePromoVideo(video);

      if (isDeviceSpecificCollectionVideo(video) && !isVideoDisplayed(video)) {
        suspendHiddenDeviceVideo(video);
        return;
      }

      if (isInViewport(video) && isVideoDisplayed(video)) {
        playPromoVideo(video, { fastStart: isVideoSplitVideo(video), force: true });
        return;
      }

      if (isNearViewport(video, video) && isVideoDisplayed(video)) {
        preloadPromoVideo(video);
        recoverStalledVideo(video);
        return;
      }

      if (!video.paused) {
        pausePromoVideo(video);
      }
    });
  }

  function clearRestoreTimers() {
    restoreTimerIds.forEach(function (timerId) {
      clearTimeout(timerId);
    });
    restoreTimerIds = [];
  }

  function refreshVideoObservers(root) {
    var scope = root && typeof root.querySelectorAll === 'function' ? root : document;

    scope.querySelectorAll(PROMO_VIDEO_SELECTOR).forEach(function (video) {
      var observers = videoObservers.get(video);

      if (!observers) {
        return;
      }

      observers.preload.unobserve(video);
      observers.play.unobserve(video);
      observers.preload.observe(video);
      observers.play.observe(video);
    });
  }

  function bindMobileGestureResume(callback) {
    function onGesture() {
      callback();
      document.removeEventListener('touchstart', onGesture, true);
      document.removeEventListener('touchend', onGesture, true);
    }

    document.addEventListener('touchstart', onGesture, { capture: true, passive: true });
    document.addEventListener('touchend', onGesture, { capture: true, passive: true });
  }

  function restoreCollectionAfterNavigation(root) {
    clearRestoreTimers();

    function runRestore() {
      syncDeviceVideoSources(root);
      refreshVideoObservers(root);
      syncPromoVideosState(root);
      bootVideoSplitPriority(root);

      document.querySelectorAll(PROMO_VIDEO_SELECTOR).forEach(recoverStalledVideo);
    }

    runRestore();

    requestAnimationFrame(function () {
      requestAnimationFrame(runRestore);
    });

    var delays = IS_TOUCH_DEVICE ? MOBILE_RESTORE_DELAYS : DESKTOP_RESTORE_DELAYS;

    delays.forEach(function (delay) {
      restoreTimerIds.push(setTimeout(runRestore, delay));
    });

    if (IS_TOUCH_DEVICE) {
      bindMobileGestureResume(runRestore);
    }
  }

  function resumeCollectionPromoVideos(root) {
    restoreCollectionAfterNavigation(root);
  }

  function bootVideoSplitPriority(root) {
    if (!isVideoSplitScope(root)) {
      return;
    }

    if (isSlowCollectionNetwork()) {
      suspendSlowNetworkCollectionVideos(root);
      return;
    }

    var scope = root && typeof root.querySelectorAll === 'function' ? root : document;
    var videos = scope.querySelectorAll(PRODUCT_VIDEO_SELECTOR);
    var eager = [];
    var visible = [];
    var deferred = [];

    videos.forEach(function (video) {
      if (!isVideoDisplayed(video)) {
        suspendHiddenDeviceVideo(video);
        return;
      }

      preparePromoVideo(video);

      if (video.dataset.collectionVideoPriority === 'high') {
        eager.push(video);
      } else if (isInViewport(video)) {
        visible.push(video);
      } else {
        deferred.push(video);
      }
    });

    eager.concat(visible).forEach(function (video) {
      preloadPromoVideo(video);
      playPromoVideo(video, { fastStart: true, force: true });
    });

    deferred.forEach(function (video, index) {
      setTimeout(function () {
        preloadPromoVideo(video);
      }, 120 + index * 90);
    });
  }

  function observePromoVideos(root) {
    var scope = root && typeof root.querySelectorAll === 'function' ? root : document;

    if (!('IntersectionObserver' in window)) {
      resumeCollectionPromoVideos(scope);
      return;
    }

    scope.querySelectorAll(PROMO_VIDEO_SELECTOR).forEach(function (video) {
      if (video.dataset.promoVideoObserved === 'true') {
        return;
      }

      video.dataset.promoVideoObserved = 'true';

      if (isDeviceSpecificCollectionVideo(video) && !isVideoDisplayed(video)) {
        suspendHiddenDeviceVideo(video);
      } else {
        preparePromoVideo(video);

        if (!isDeviceSpecificCollectionVideo(video)) {
          if (isInViewport(video) || isNearViewport(video, video)) {
            preloadPromoVideo(video);
          }
        }
      }

      var videoSplit = isVideoSplitVideo(video);
      var preloadMargin = getPromoPreloadRootMargin(video);
      var playMargin = getPromoPlayRootMargin(video);
      var playThresholds = videoSplit ? [0, 0.01, 0.1] : IS_TOUCH_DEVICE ? [0, 0.01, 0.1] : [0, 0.15, 0.35];

      var preloadObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) {
              return;
            }

            if (
              isDeviceSpecificCollectionVideo(entry.target) &&
              !isVideoDisplayed(entry.target)
            ) {
              suspendHiddenDeviceVideo(entry.target);
              return;
            }

            preloadPromoVideo(entry.target);

            if (shouldFastStartPromoVideo(entry.target)) {
              playPromoVideo(entry.target, { fastStart: true, force: true });
            }
          });
        },
        { rootMargin: preloadMargin, threshold: 0 }
      );

      var playObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && entry.intersectionRatio > 0) {
              playPromoVideo(entry.target, {
                fastStart: shouldFastStartPromoVideo(entry.target),
                force: true
              });
            } else if (!entry.isIntersecting) {
              if (isIOSSafari() && isNearViewport(entry.target, entry.target)) {
                return;
              }

              schedulePause(entry.target);
            } else if (!isIOSSafari() && entry.intersectionRatio === 0) {
              schedulePause(entry.target);
            }
          });
        },
        { rootMargin: playMargin, threshold: playThresholds }
      );

      preloadObserver.observe(video);
      playObserver.observe(video);
      videoObservers.set(video, { preload: preloadObserver, play: playObserver });
    });
  }

  function isPromoClampedCard(card) {
    return (
      card.classList.contains('product-card--promo') && !!card.querySelector('.collection-promo-media--clamped')
    );
  }

  function isReferenceProductCard(card) {
    return (
      !card.classList.contains('product-card--promo') &&
      !card.classList.contains('product-card--featured-placeholder') &&
      !card.hasAttribute('data-featured-product-placeholder')
    );
  }

  var heightSyncTimers = new WeakMap();
  var heightResizeObservers = new WeakMap();
  var isSyncingPromoHeights = false;

  function getProductListsFromScope(root) {
    var scope = root && typeof root.querySelector === 'function' ? root : document;

    if (scope === document) {
      return Array.prototype.slice.call(
        document.querySelectorAll('.shopify-section--main-collection product-list, product-list')
      );
    }

    if (scope.matches && scope.matches('product-list')) {
      return [scope];
    }

    if (scope.matches && scope.matches('.shopify-section--main-collection')) {
      return Array.prototype.slice.call(scope.querySelectorAll('product-list'));
    }

    if (scope.closest) {
      var parentList = scope.closest('product-list');

      if (parentList) {
        return [parentList];
      }
    }

    if (scope.querySelectorAll) {
      return Array.prototype.slice.call(
        scope.querySelectorAll('.shopify-section--main-collection product-list, product-list')
      );
    }

    return [];
  }

  function schedulePromoHeightSync(root) {
    var lists = getProductListsFromScope(root);

    if (!lists.length) {
      lists = [document];
    }

    lists.forEach(function (list) {
      var existingTimer = heightSyncTimers.get(list);

      if (existingTimer) {
        clearTimeout(existingTimer);
      }

      heightSyncTimers.set(
        list,
        setTimeout(function () {
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              syncPromoCardHeights(list);
            });
          });
        }, 50)
      );
    });
  }

  function resetSyncedPromoCardHeights(cards) {
    cards.forEach(function (card) {
      if (!isPromoClampedCard(card)) {
        return;
      }

      card.classList.remove('collection-promo-height-synced');
      card.style.removeProperty('--promo-card-sync-height');
      card.style.removeProperty('min-height');
      card.style.removeProperty('max-height');
      card.style.removeProperty('height');
    });
  }

  function syncPromoCardHeights(root) {
    isSyncingPromoHeights = true;

    getProductListsFromScope(root).forEach(function (list) {
      if (!list) {
        return;
      }

      var cards = Array.prototype.slice.call(list.querySelectorAll('product-card'));

      resetSyncedPromoCardHeights(cards);
      void list.offsetHeight;

      var rows = [];

      cards.forEach(function (card) {
        var top = Math.round(card.getBoundingClientRect().top);
        var row = null;

        for (var i = 0; i < rows.length; i++) {
          if (Math.abs(rows[i].top - top) <= 8) {
            row = rows[i];
            break;
          }
        }

        if (!row) {
          row = { top: top, cards: [] };
          rows.push(row);
        }

        row.cards.push(card);
      });

      rows.forEach(function (row) {
        var targetHeight = 0;

        row.cards.forEach(function (card) {
          if (!isReferenceProductCard(card)) {
            return;
          }

          targetHeight = Math.max(targetHeight, Math.round(card.getBoundingClientRect().height));
        });

        if (!targetHeight) {
          return;
        }

        row.cards.forEach(function (card) {
          if (!isPromoClampedCard(card)) {
            return;
          }

          card.style.setProperty('--promo-card-sync-height', targetHeight + 'px');
          card.classList.add('collection-promo-height-synced');
        });
      });

      list.querySelectorAll('product-card:not(.product-card--promo) img').forEach(function (image) {
        if (image.complete) {
          return;
        }

        image.addEventListener(
          'load',
          function () {
            schedulePromoHeightSync(list);
          },
          { once: true }
        );
      });
    });

    requestAnimationFrame(function () {
      isSyncingPromoHeights = false;
    });
  }

  function boot(root) {
    syncSlowNetworkVideoCardsFlag();
    observePromoVideos(root);

    if (suspendSlowNetworkCollectionVideos(root)) {
      syncPromoCardHeights(root);
      schedulePromoHeightSync(root);
      return;
    }

    syncDeviceVideoSources(root);
    initVideoLoadDebugger();
    bootVideoSplitPriority(root);
    preloadVideosInSubtree(root);
    syncPromoCardHeights(root);

    requestAnimationFrame(function () {
      syncDeviceVideoSources(root);
      bootVideoSplitPriority(root);
      preloadVideosInSubtree(root);
      syncPromoCardHeights(root);

      if (!isVideoSplitScope(root)) {
        syncPromoVideosState(root);
      }

      schedulePromoHeightSync(root);
      setTimeout(function () {
        schedulePromoHeightSync(root);
      }, 300);

      setTimeout(function () {
        schedulePromoHeightSync(root);
      }, 1000);
    });
  }

  function bindPromoHeightObservers(list) {
    if (!list || list.dataset.promoHeightObserved === 'true') {
      return;
    }

    list.dataset.promoHeightObserved = 'true';

    if ('ResizeObserver' in window) {
      var observer = new ResizeObserver(function () {
        if (isSyncingPromoHeights) {
          return;
        }

        schedulePromoHeightSync(list);
      });

      observer.observe(list);
      heightResizeObservers.set(list, observer);
    }
  }

  function watchProductLists() {
    document.querySelectorAll('.shopify-section--main-collection product-list').forEach(function (list) {
      bindPromoHeightObservers(list);

      if (list.dataset.promoVideoWatch === 'true') {
        return;
      }

      list.dataset.promoVideoWatch = 'true';

      new MutationObserver(function (mutations) {
        var hasAdds = false;

        mutations.forEach(function (mutation) {
          for (var i = 0; i < mutation.addedNodes.length; i++) {
            var node = mutation.addedNodes[i];

            if (node.nodeType === 1) {
              boot(node);
              hasAdds = true;
            }
          }
        });

        if (hasAdds) {
          schedulePromoHeightSync(list);
          recoverVisiblePromoVideos();
        }
      }).observe(list, { childList: true });
    });
  }

  function onPageShow(event) {
    if (!hasCollectionVideos()) {
      return;
    }

    if (event.persisted || pageHasBeenHidden) {
      restoreCollectionAfterNavigation();
    }
  }

  function onPageHide() {
    pageHasBeenHidden = true;

    document.querySelectorAll(PROMO_VIDEO_SELECTOR).forEach(function (video) {
      if (!video.paused && isInViewport(video)) {
        video.dataset.promoVideoWasPlaying = 'true';
      }

      clearScheduledPause(video);
      pausePromoVideo(video);
    });
  }

  function onVisibilityChange() {
    if (document.visibilityState === 'hidden') {
      pageHasBeenHidden = true;

      document.querySelectorAll(PROMO_VIDEO_SELECTOR).forEach(function (video) {
        clearScheduledPause(video);
        pausePromoVideo(video);
      });
      return;
    }

    if (document.visibilityState === 'visible' && hasCollectionVideos()) {
      restoreCollectionAfterNavigation();
    }
  }

  function onPopState() {
    if (!hasCollectionVideos()) {
      return;
    }

    restoreCollectionAfterNavigation();
  }

  function onWindowFocus() {
    if (!hasCollectionVideos() || document.visibilityState !== 'visible') {
      return;
    }

    if (pageHasBeenHidden) {
      restoreCollectionAfterNavigation();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
      watchProductLists();
      bindViewportVideoSync();
      bindMobileScrollVideoRecovery();
      bindIOSVideoPlayback();
    });
  } else {
    boot();
    watchProductLists();
    bindViewportVideoSync();
    bindMobileScrollVideoRecovery();
    bindIOSVideoPlayback();
  }

  function recoverVisiblePromoVideos() {
    if (!isMobileVideoContext()) {
      return;
    }

    document.querySelectorAll(PROMO_VIDEO_SELECTOR).forEach(function (video) {
      if (!isVideoDisplayed(video) || !isInViewport(video)) {
        return;
      }

      var lastTime = videoLastTimes.get(video);
      var currentTime = video.currentTime;
      var appearsFrozen =
        !video.paused &&
        video.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA &&
        lastTime !== undefined &&
        Math.abs(currentTime - lastTime) < 0.01;

      videoLastTimes.set(video, currentTime);

      if (isStalledVideo(video) || video.paused || appearsFrozen) {
        if (appearsFrozen) {
          resetVideoPlaybackFlags(video);

          try {
            video.pause();
          } catch (error) {}
        }

        recoverStalledVideo(video);
        playPromoVideo(video, { fastStart: true, force: true });
      }
    });
  }

  function bindMobileScrollVideoRecovery() {
    if (!isMobileVideoContext()) {
      return;
    }

    function onScroll() {
      clearTimeout(scrollRecoveryTimer);
      scrollRecoveryTimer = setTimeout(recoverVisiblePromoVideos, 200);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function bindIOSVideoPlayback() {
    if (!isIOSSafari()) {
      return;
    }

    var unlocked = false;

    function playVisibleIOSVideos() {
      document.querySelectorAll(PROMO_VIDEO_SELECTOR).forEach(function (video) {
        if (!isVideoDisplayed(video) || !isInViewport(video)) {
          return;
        }

        playPromoVideo(video, { fastStart: true, force: true });
      });
    }

    function unlockIOSVideos() {
      if (unlocked) {
        return;
      }

      unlocked = true;
      playVisibleIOSVideos();
      document.removeEventListener('touchstart', unlockIOSVideos, true);
    }

    playVisibleIOSVideos();

    requestAnimationFrame(function () {
      requestAnimationFrame(playVisibleIOSVideos);
    });

    [300, 800, 1500].forEach(function (delay) {
      setTimeout(playVisibleIOSVideos, delay);
    });

    document.addEventListener('touchstart', unlockIOSVideos, { capture: true, passive: true });
  }

  function bindViewportVideoSync() {
    var resizeTimer;

    function onViewportChange() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        schedulePromoHeightSync(document);

        if (hasCollectionVideos()) {
          syncPromoVideosState();
          recoverVisiblePromoVideos();
        }
      }, 150);
    }

    window.addEventListener('resize', onViewportChange);
    window.addEventListener('orientationchange', onViewportChange);

    if (typeof window.matchMedia === 'function') {
      window.matchMedia('(max-width: 767px)').addEventListener('change', onViewportChange);
    }
  }

  window.addEventListener('pageshow', onPageShow);
  window.addEventListener('pagehide', onPageHide);
  window.addEventListener('popstate', onPopState);
  window.addEventListener('focus', onWindowFocus);
  document.addEventListener('visibilitychange', onVisibilityChange);

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.classList.contains('shopify-section--main-collection')) {
      boot(event.target);
      watchProductLists();
      bindIOSVideoPlayback();
    }
  });

  document.addEventListener(
    'click',
    function (event) {
      var link = event.target.closest('.shopify-section--main-collection a[href*="/products/"]');

      if (!link) {
        return;
      }

      pageHasBeenHidden = true;
    },
    true
  );

  window.CollectionPromoCards = {
    init: boot,
    resumeVideos: resumeCollectionPromoVideos,
    syncVideos: syncPromoVideosState,
    syncHeights: syncPromoCardHeights,
    scheduleHeightSync: schedulePromoHeightSync,
    recoverVisibleVideos: recoverVisiblePromoVideos,
    restoreAfterNavigation: restoreCollectionAfterNavigation,
    isSlowNetwork: isSlowCollectionNetwork,
    enableVideoDebug: function () {
      try {
        localStorage.setItem(VIDEO_DEBUG_KEY, '1');
      } catch (error) {}

      initVideoLoadDebugger();
    },
    disableVideoDebug: function () {
      try {
        localStorage.removeItem(VIDEO_DEBUG_KEY);
      } catch (error) {}
    }
  };
})();
